<template>
<div class="chapter">
<div class="inner_page">
<div class="c"><img alt="“ARE YOU THE M. JACKSON THEN WHO HAD AN AVERAGE OF FIFTY ONE POINT NOUGHT THREE LAST YEAR?”" class="calibre2" src="OEBPS/Images/Images0001.jpg"/></div>
<h4 class="sigilnotintoc2" id="pgepubid00008">[Dedication]<br class="calibre1"/>
  TO<br class="calibre1"/>
  ALAN DURAND</h4>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?5570839e